import Image from 'next/image';
import React from 'react';
import { ImageContainer } from './styled';
import { getScreenName } from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';

export default function index(props) {
  const { data, topBannerTitle, articleData } = props;
  const bannerClickHandler = () => {
    fireEvent({
      category: 'clicked_card_in_article_page',
      parent: articleData?.title?.slice(0, 99),
      support_variable: 'banner',
      content_id: articleData?.id,
      screen_name: getScreenName(),
    });
  };
  return (
    <>
      {data && data[0] && (
        <ImageContainer onClick={bannerClickHandler}>
          {/* <img
                        src={`${data[0]}?tr=w-360,q-60`}
                        alt=""
                        srcSet={`${data[0]}?tr=w-360,q-60 2w, ${data[0]}?tr=w-550,q-60 608w`}
                        sizes="(max-width: 720px) 2px,608px"
                    /> */}
          <Image
            src={data[0]}
            alt={topBannerTitle}
            quality={90}
            priority={true}
            fill
            sizes="40vw"
          />
        </ImageContainer>
      )}
    </>
  );
}
